import Enum from '/@/modules/core/app/helpers/Enum';

export class PredefinedUserRole extends Enum {
  id!: number;
  key!: string;
  value!: string;

  static DEFAULT: PredefinedUserRole = {
    id: 1,
    key: 'default',
    value: 'Default'
  };

  static SUPER_ADMIN: PredefinedUserRole = {
    id: 2,
    key: 'super_admin',
    value: 'Super Admin'
  };

  static ADMIN: PredefinedUserRole = {
    id: 3,
    key: 'admin',
    value: 'Administrator'
  };
}
